import {
    RefreshCw,
    ClipboardCheck,
    FileCodeIcon as FileContract,
    Calendar,
    HelpCircle,
    ClipboardList,
    Wrench,
    PackageOpen,
  } from "lucide-react";

  import baghouse from "../assets/images/service-items/1.webp";
  import engineering from "../assets/images/service-items/2.webp";
  import master from "../assets/images/service-items/3.webp";
  import preventive from "../assets/images/service-items/4.webp";
  import troubleshooting from "../assets/images/service-items/5.webp";
  import inspections from "../assets/images/service-items/6.webp";
  import maintenance from "../assets/images/service-items/7.webp";
  import filterbag from "../assets/images/service-items/8.webp";


  
  export const SERVICES = [
    {
      title: "Baghouse Conversions",
      img: baghouse,
      slug: "baghouse-conversions", // Manually added slug, or use slugify()
      icon: <RefreshCw color="#0076fe" />,
      description:
        "Upgrade outdated baghouse systems to more efficient configurations tailored to current process demands, regulations, or air quality goals.",
      includes: [
        "Conversion of mechanical shaker or reverse air systems to pulse-jet",
        "Retrofitting cartridge-style units or pleated filter bag solutions",
        "Air-to-cloth ratio optimization",
        "Fan sizing and ductwork modifications",
        "Control system upgrades (e.g., VFD integration, automated differential pressure control)",
      ],
    },
    {
      title: "Engineering Evaluations",
      img: engineering,
      slug: "engineering-evaluations", // Manually added slug, or use slugify()
      icon: <ClipboardCheck color="#0076fe" />,
      description:
        "Comprehensive technical assessments to evaluate the performance, design, and compliance of your dust collection or filtration system.",
      includes: [
        "Airflow and velocity measurements",
        "Differential pressure diagnostics",
        "System performance modeling",
        "Emissions risk and OSHA/MACT compliance analysis",
        "Life cycle cost analysis and retrofit feasibility studies",
      ],
    },
    {
      title: "Master Service Contracts",
      img: master,
      slug: "master-service-contracts", // Manually added slug, or use slugify()
      icon: <FileContract color="#0076fe" />,
      description:
        "Long-term, bundled service agreements tailored for clients with multiple sites or recurring needs, offering priority response and discounted rates.",
      includes: [
        "Scheduled preventive maintenance",
        "Annual or semi-annual system audits",
        "Emergency response priority",
        "Customized reporting and performance tracking",
        "Spare parts inventory management",
      ],
    },
    {
      title: "Preventive Maintenance Plans",
      img: preventive,
      slug: "preventive-maintenance-plans", // Manually added slug, or use slugify()
      icon: <Calendar color="#0076fe" />,
      description:
        "Planned service routines designed to extend equipment life, ensure compliance, and minimize costly unplanned downtime.",
      includes: [
        "Filter integrity checks",
        "Pulse valve and solenoid inspections",
        "Leak testing and gasket integrity checks",
        "Cleaning of hoppers and ductwork",
        "Fan alignment, lubrication, and motor inspection",
        "Scheduled filter change forecasts",
      ],
    },
    {
      title: "Troubleshooting",
      img: troubleshooting,
      slug: "troubleshooting", // Manually added slug, or use slugify()
      icon: <HelpCircle color="#0076fe" />,
      description:
        "Rapid diagnostics and root-cause analysis to resolve operational issues, excessive emissions, or system alarms.",
      includes: [
        "Identification of system imbalances or blockages",
        "Solenoid/valve sequencing review",
        "Filter blinding and differential pressure issues",
        "Excess dust carryover or emissions testing",
        "On-site fixes or escalation planning",
      ],
    },
    {
      title: "Inspections & Reports",
      img: inspections,
      slug: "inspections-reports", // Manually added slug, or use slugify()
      icon: <ClipboardList color="#0076fe" />,
      description:
        "Detailed evaluations supported by visual inspections, performance data, and expert recommendations for corrective action.",
      includes: [
        "Visual and operational inspection of all components",
        "Photo documentation and summary of findings",
        "Measured system metrics (e.g., pressure drops, airflow, emissions)",
        "Compliance gap identification",
        "Digital report delivery with maintenance and CAPEX recommendations",
      ],
    },
    {
      title: "Maintenance Repairs",
      img: maintenance,
      slug: "maintenance-repairs", // Manually added slug, or use slugify()
      icon: <Wrench color="#0076fe" />,
      description:
        "On-call or scheduled repairs to restore functionality and maintain peak performance of your dust collection system.",
      includes: [
        "Damper, fan, and motor replacements",
        "Pulse jet system component repairs",
        "Structural and weld repairs",
        "Door seal, gasket, and cage replacements",
        "Emergency response for breakdowns",
      ],
    },
    {
      title: "Filter Bag Changeovers",
      img: filterbag,
      slug: "filter-bag-changeovers", // Manually added slug, or use slugify()
      icon: <PackageOpen color="#0076fe" />,
      description:
        "Professional removal and installation of filter bags to minimize downtime and prevent contamination.",
      includes: [
        "Removal of spent filters and cages",
        "Installation of new filter bags with correct fit and sealing",
        "Gasket and seal inspection/replacement",
        "Dust handling and waste disposal coordination",
        "Initial startup testing post-change",
      ],
    },
  ];
  